import styled from "styled-components";

export const Wrapper = styled.div`
height: 100%;
`
export const Back = styled.button`
display: flex;
justify-content: start;
align-items: center;
margin-left: 20px;
margin-top: 10px;
background-color: transparent;
border: 0;
span{
    padding-left: 10px;
    color: #2555EF;
    font-size:16px;
}
`

export const Title = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
flex-wrap: wrap;
gap: 12px 20px;
width: 100%;
margin-top: 20px;
margin-left: 25px;
padding-right: 25px;
`
export const MetaLabel = styled.span`
font-size: 14px;
color: #7B7B8B;

strong {
  font-size: 14px;
  font-weight: 600;
  color: #404253;
}

&.campaign-type-meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
`
export const StatusWrapper = styled.div`
width: fit-content;
border-radius: 5px;
padding: 5px;
font-size: 14px;
margin-right: 0;
background-color: ${(props) => (props.status === 'running' ? 'rgb(37 85 239 / 20%)' :
        props.status === 'scheduled' ? "#ffce7eb5" : props.status === 'paused' ? "rgb(250 51 114 / 20%)" : props.status === 'completed' ? "#28c23833" :
            props.status === 'draft' ? "#d8d3d3" : '')};
 color: ${(props) => (props.status === 'running' ? '#2555EF' :
        props.status === 'scheduled' ? "orange" : props.status === 'paused' ? "#FA3372" : props.status === 'completed' ? "#28c238" :
            props.status === 'draft' ? "#8E8E8E" : '')};
`
export const Details = styled.div`
height: 100%;
display: flex;
margin-top: 10px;
`
export const LeftSide = styled.div`
width: ${(props) => (props.isZero ? '98%' : '66%')};
`
export const RightSide = styled.div`
width: 30%;
border: 1px  solid rgb(0 0 0 / 20%);
border-radius: 5px;
margin-left: 30px;
height: 75%;
padding-top: 20px;
margin-top: 15px;
`
export const StatusDetails = styled.div`
width: 100%;
display: flex;
flex-direction:'row'
`
export const StatusContent = styled.div`
display: flex;
flex-direction: column;
align-items: start;
justify-content:start;
color: rgb(64 66 83 / 100%);
p{
    font-size: 16px;
    padding-bottom: 8px;
}
span{
color: #2555EF;
font-size: 32px;
line-height: 25.6px;
font-weight: bold;
}
`

export const TableDetails = styled.div`
height: 100%;
border: 1px  solid rgb(0 0 0 / 20%);
border-radius: 5px;
margin-top: 10px;
height: 500px;
margin-left:25px;
`
export const NameWrapper = styled.div`
display: flex;
justify-content: start;
align-items: center;
flex-direction: row;
span{
    padding-left: 10px;
}
`
export const TableFilter = styled.div`
display: flex;
justify-content: start;
align-items: baseline;
flex-direction: row;
width: 32%;
padding: 15px;
span{
    font-size: 18px;
    font-weight: bold;
    color: #2555EF;
    padding-right: 20px;
}
`
export const ChartTitle = styled.span`
font-size: 20px;
font-weight: bold;
margin-top: 20px;
margin-left: 20px;
`